import React from "react";
import ReactDOM from "react-dom";
import TutoringSection from "../components/TutoringSection";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderTutoringSection = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<TutoringSection props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering TutoringSection:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
